import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from '../../components/shared/Sidebar';
import Header from '../../components/shared/Header';
import './RestaurantDetail.css';

const RestaurantDetail: React.FC = () => {
  const { restaurantId } = useParams<{ restaurantId: string }>();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [activeTab, setActiveTab] = useState<'menu' | 'deals' | 'orders'>('menu');

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  return (
    <div className="dashboard-container restaurant-detail-layout">
      <Sidebar
        collapsed={sidebarCollapsed}
        onToggle={toggleSidebar}
      />
      <div className={`dashboard-main ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <Header page="restaurants" />
        <main className="dashboard-content restaurant-detail-page">
          <div className="restaurant-detail-header">
            <div>
              <h1 className="restaurant-detail-title">Restaurant Details</h1>
              <p className="restaurant-detail-subtitle">
                {restaurantId
                  ? `Details for ${restaurantId}`
                  : 'View restaurant profile, menu, deals, and orders.'}
              </p>
            </div>
          </div>

          <div className="restaurant-detail-tabs">
            <button
              className={`restaurant-detail-tab ${activeTab === 'menu' ? 'active' : ''}`}
              onClick={() => setActiveTab('menu')}
            >
              Menu
            </button>
            <button
              className={`restaurant-detail-tab ${activeTab === 'deals' ? 'active' : ''}`}
              onClick={() => setActiveTab('deals')}
            >
              Deals
            </button>
            <button
              className={`restaurant-detail-tab ${activeTab === 'orders' ? 'active' : ''}`}
              onClick={() => setActiveTab('orders')}
            >
              Orders
            </button>
          </div>

          <div className="restaurant-detail-content">
            {activeTab === 'menu' && (
              <div className="restaurant-detail-section">
                <h2>Menu</h2>
                <p>Menu management UI for this restaurant will go here.</p>
              </div>
            )}
            {activeTab === 'deals' && (
              <div className="restaurant-detail-section">
                <h2>Deals</h2>
                <p>Deals configured for this restaurant will appear here.</p>
              </div>
            )}
            {activeTab === 'orders' && (
              <div className="restaurant-detail-section">
                <h2>Orders</h2>
                <p>Recent orders for this restaurant will appear here.</p>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default RestaurantDetail;